import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { ArrowRight } from "iconsax-react";

import InputComponent from "../../../../public/form/input";
import ButtonComponent from "../../../../public/button";

import {
  ContainerPriceCanWithdraw,
  PriceChoicesButton,
  SectionWithdrawInfo,
} from "./styledUserWalletWithdrawComponent";

function UserWalletWithdrawComponent(props) {
  const history = useHistory();
  const [priceChoices, setPriceChoices] = useState(1);
  const priceChoicesArray = [
    { price: 20000, id: 1 },
    { price: 50000, id: 2 },
    { price: 100000, id: 3 },
  ];

  return (
    <div>
      <ArrowRight onClick={() => history.goBack()} />

      <SectionWithdrawInfo>
        <div className="col-sm-8 mx-auto">
          <h5 className={"text-center"}>برداشت وجه</h5>
          <ContainerPriceCanWithdraw className={"text-center"}>
            <span>مبلغ قابل برداشت:</span>
            <span> 5,000,000 تومان</span>
          </ContainerPriceCanWithdraw>
          <form className={""}>
            <div className={"my-5"}>
              <p className={"text-center m-0"}>مبلغ مورد نظر را وارد نمایید.</p>
              <InputComponent className={"text-start "} iconEnd={"ریال"} withBorder />
            </div>
            <div className={"my-5"}>
              <p className={"text-center m-0"}>
                انتقال به حساب شخصی( شماره شبای حساب خود را وارد کنید.)
              </p>
              <InputComponent className={"text-start "} iconEnd={"IR"} withBorder />
            </div>
          </form>
          <div className={"d-flex justify-content-between my-3"}>
            <ButtonComponent className={"col-sm-4"}>انصراف</ButtonComponent>
            <ButtonComponent className={"col-sm-7"}>پرداخت</ButtonComponent>
          </div>
        </div>
      </SectionWithdrawInfo>
    </div>
  );
}
export default UserWalletWithdrawComponent;
